import Activities from 'ent-capability-gateway-react/Activities/Activities';
import Administration from "twia-capability-agencyadmin-react/pages/Administration/Administration";
import AddUser from "twia-capability-agencyadmin-react/components/AddUser/AddUser";
import EditUser from "twia-capability-agencyadmin-react/components/EditUser/EditUser";
import DeactivateAgency from "twia-capability-agencyadmin-react/components/DeactivateAgency/DeactivateAgency";
import AccountDetails from './Accounts/AccountDetails/AccountDetails';
import Accounts from './Accounts/Accounts';
import accountMessages from './Accounts/Accounts.messages';
import AccountBillingAndPayment from './Accounts/BillingAndPayment/BillingAndPayment';
import MakePayment from './Accounts/BillingAndPayment/MakePayment/MakePayment';
import PaymentConfirmation from './Accounts/BillingAndPayment/PaymentConfirmation/PaymentConfirmation';
import Analytics from './Analytics/Analytics';
import Cancellation from './Cancellation/Cancellation';
import ContactRoles from './Components/ContactRoles/ContactRoles';
import ContactUnderwriter from './ContactUnderwriter/ContactUnderwriter';
import Endorsement from './Endorsement/Endorsement';
import gatewayMessages from './gateway.messages';
import LandingPage from './LandingPage/LandingPage';
import NewQuotePage from './NewQuote/NewQuote/NewQuotePage';
import NewQuoteAccountSearch from './NewQuote/NewQuoteAccountSearch';
import Policies from './Policies/Policies';
import PolicyDetails from './Policies/PolicyDetails/PolicyDetails';
import QuoteDetails from './QuoteDetails/QuoteDetails';
import Renewal from './Renewal/Renewal';
import SearchResults from './SearchResults/SearchResults';
import SRELandingPage from './SRELandingPage/SRELandingPage';
import ENTDdocumentUploadComponent from './Components/ENTDocumentUpload/ENTDocumentUploadComponent';

const producerEngageComponentMap = {
    ContactRoles: { component: 'ContactRoles' },
};

const producerEngageAdditionalComponents = {
    ContactRoles,
};

// eslint-disable-next-line no-secrets/no-secrets
export { default as AutomaticPaymentPolicyAffectedValueIterableComponent } from './Accounts/BillingAndPayment/AutomaticPaymentPolicyAffectedValueIterableComponent';
export { default as summaryMessages } from './Endorsement/Summary/Summary.messages';
export {
    // eslint-disable-next-line no-restricted-exports
    LandingPage as default,
    SRELandingPage,
    Accounts,
    Policies,
    Activities,
    Analytics,
    AccountDetails,
    PolicyDetails,
    NewQuoteAccountSearch,
    NewQuotePage,
    SearchResults,
    QuoteDetails,
    Renewal,
    Endorsement,
    Cancellation,
    AccountBillingAndPayment,
    MakePayment,
    ContactUnderwriter,
    PaymentConfirmation,
    ContactRoles,
    producerEngageComponentMap,
    producerEngageAdditionalComponents,
    gatewayMessages,
    accountMessages,
    Administration,
    AddUser,
    DeactivateAgency,
    EditUser, // DE15292
    ENTDdocumentUploadComponent
};
